import jquery from "jquery";
import "bootstrap";


/* Import Custom Scripts */
window.$ = window.jQuery = jquery;